import React, { Component } from 'react'
import LOGO from '../img/Server error@3x.png'
 class Servererror extends Component {
    render() {
       let img={
            width: this.props.width
        }
        let divbody={
            marginTop:this.props.marginTop,
            alignItems: "center",
             color: "gray",
            fontWeight: "bold",
            padding: "50px",
            display: "flex",
            flexDirection: "column"
        }
        return (
            <div>
            <div style={divbody}>
            <img height="200px" width="200px" style={{alignItems:"center"}} src={LOGO} alt="No Data"></img>
            <h5 style={{color:"grey",textAlign:"center"}}>{this.props.msg}</h5>
            </div>
            </div>
        )
    }
}

export default Servererror
